import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, Typography, Link } from '@material-ui/core';
import { useAuthorizeCheckboxStyles } from '../AuthorizeCheckbox/styles';
import arcoLawTerms from '../../../assets/arcoRights/terminos_y_condiciones_derechos_ARCO_28_07_25.pdf';

const AuthorizeArcoTerms = ({ ...props }) => {
  const { disabled, onCheck } = props;
  const classes = useAuthorizeCheckboxStyles();
  const [checked, setChecked] = useState(false);

  const handleCheck = () => {
    setChecked(!checked);
    onCheck(!checked);
  };

  return (
    <Box className={classes.box}>
      <Checkbox
        className={classes.checkbox}
        onChange={handleCheck}
        checked={checked}
        disabled={disabled}
      />
      <Typography className={classes.text}>
        Acepto los{' '}
        <Link href={arcoLawTerms} target="_blank">
          Términos y Condiciones
        </Link>{' '}
        para ejercer derechos <strong>ARCO</strong>
      </Typography>
    </Box>
  );
};

AuthorizeArcoTerms.propTypes = {
  disabled: PropTypes.bool,
  onCheck: PropTypes.func,
};

export default AuthorizeArcoTerms;
